import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createTextVNode as _createTextVNode, unref as _unref, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-4b5f3e84"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "flex center top" }
const _hoisted_2 = { class: "text_number" }

import { withDefaults, ref, watch } from 'vue';
import { Modal } from 'ant-design-vue';
import emitter from '@/utils/mitt';
interface Props {
  visible: boolean;
  centered?: boolean;
  closable?: boolean;
  footer?: null;
  ok: (...args: any[]) => any;
  close: (...args: any[]) => any;
}

export default /*#__PURE__*/_defineComponent({
  __name: 'CCreateCategory',
  props: {
    visible: { type: Boolean, default: false },
    centered: { type: Boolean, default: false },
    closable: { type: Boolean, default: true },
    footer: null,
    ok: null,
    close: null
  },
  setup(__props: any) {

const props = __props as { visible: boolean, centered: boolean, closable: boolean, footer?: null, ok: (...args: any[]) => any, close: (...args: any[]) => any };

const aModal = Modal;



const categoryName = ref('');

const sortName = () => {
  let params = {
    name: categoryName.value,
  };
  emitter.emit('createSortName', params);
};
const clear = () => {
  categoryName.value = '';
};
watch(
  () => props.visible,
  () => {
    !props.visible ? clear() : '';
  }
);

return (_ctx: any,_cache: any) => {
  const _component_a_input = _resolveComponent("a-input")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createVNode(_unref(aModal), {
      title: "添加分类",
      visible: props.visible,
      centered: props.centered,
      closable: props.closable,
      onCancel: props.close,
      onOk: props.ok
    }, {
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_1, [
          _createTextVNode(" 分类名称： "),
          _createVNode(_component_a_input, {
            class: "input_width",
            value: categoryName.value,
            "onUpdate:value": _cache[0] || (_cache[0] = ($event: any) => ((categoryName).value = $event)),
            onChange: sortName,
            placeholder: "请输入分类名称",
            maxlength: 20,
            size: "small"
          }, {
            suffix: _withCtx(() => [
              _createElementVNode("div", _hoisted_2, _toDisplayString(categoryName.value.length) + "/20", 1)
            ]),
            _: 1
          }, 8, ["value"])
        ])
      ]),
      _: 1
    }, 8, ["visible", "centered", "closable", "onCancel", "onOk"])
  ]))
}
}

})